const CoursesPop = ({ skill }) => {
    return (
        <div className="modal_body">
            <div className="attached_courses">
                <h2>attached skills <span className="mt_2">{skill.userdetails?.first_name ? skill.userdetails?.first_name?.toLowerCase() : 'dfgdf'} {skill.userdetails?.last_name ? skill.userdetails?.last_name?.toLowerCase() : '45456'}</span></h2>
                {
                    skill.skill_name
                        ? skill?.skill_name?.map(ski => (
                            <p>{ski}<span className="mt_2"></span></p>
                        ))
                        : skill?.skill?.map(ski => (
                            <p>{ski.name}<span className="mt_2"></span></p>
                        ))
                }
            </div>
        </div>
    )
};

export default CoursesPop;